import React from "react";
import Loader from "./Loader";

interface VerticalTableProps {
  headers: string[];
  data: { category: string; values: string[] }[];
  loading: boolean;
}

const VerticalTable: React.FC<VerticalTableProps> = ({ headers, data, loading }) => {
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
        <Loader />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return <p>No data available for the selected criteria</p>;
  }

  return (
    <div className="table-responsive" style={{ overflowX: "auto" }}>
      <table
        className="table table-bordered table-hover"
        style={{
          margin: "20px",
          whiteSpace: "nowrap", // prevents text wrap
        }}
      >
        <thead>
          <tr style={{ fontSize: 12, fontWeight: 300 }}>
            {headers.map((header, index) => (
              <th
                className="tableHead"
                style={{
                  textAlign: "center",
                  fontWeight: 500,
                  padding: "8px",
                }}
                key={index}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody style={{ fontSize: 13, fontWeight: 400 }}>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td
                className="text-start align-middle ps-3"
                style={{ fontWeight: 500, padding: "8px" }}
              >
                {row.category}
              </td>
              {row.values.map((value, colIndex) => (
                <td
                  key={colIndex}
                  style={{
                    textAlign: "center",
                    padding: "8px",
                  }}
                >
                  {value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VerticalTable;
